export const volumes = [
  {
    number: '1',
    title: 'Diagnóstico de fallas en disyuntores y térmicas',
    subtitle: 'Aprendé a interpretar los síntomas y diferenciar posibles causas.',
    intro: [
      'Accedé a casos prácticos relacionados con el funcionamiento de disyuntores diferenciales y llaves termomagnéticas.',
      'Encontrá situaciones como disparos inesperados, sobrecargas, cortocircuitos, problemas de aislamiento y fallas que aparecen al utilizar determinados equipos.',
      'Cada caso desarrolla una situación concreta, datos técnicos, posibles causas, interpretación del problema y una solución justificada.',
    ],
    listLabel: 'Vas a encontrar actividades como:',
    items: [
      'Análisis de disparos de disyuntores diferenciales',
      'Interpretación de fallas por sobrecarga',
      'Casos relacionados con cortocircuitos',
      'Problemas asociados a determinados electrodomésticos',
      'Fallas vinculadas con humedad',
      'Ejercicios de análisis de protecciones',
      'Interpretación de datos de mediciones simuladas',
      'Criterios de verificación después de una corrección',
    ],
    outro: 'En lugar de limitarte a una explicación general, podés consultar ejemplos completos que muestran cómo se analiza cada situación.',
    finalLine: 'Identificá. Compará. Diagnosticá.',
  },
  {
    number: '2',
    title: 'Fallas en tomacorrientes, iluminación y circuitos domiciliarios',
    subtitle: 'Soluciones prácticas para problemas eléctricos habituales en viviendas.',
    intro: [
      'Este tomo reúne situaciones que pueden aparecer durante reparaciones, modificaciones e inspecciones domiciliarias.',
      'Desde tomacorrientes que dejan de funcionar hasta problemas en iluminación LED, conexiones defectuosas y circuitos con comportamiento irregular.',
      'Cada caso permite comprender el problema, analizar la información disponible y distinguir entre posibles causas.',
    ],
    listLabel: 'Incluye situaciones como:',
    items: [
      'Tomacorrientes sin alimentación',
      'Conexiones deterioradas',
      'Problemas de continuidad',
      'Fallas en circuitos de iluminación',
      'Luces LED que parpadean',
      'Problemas con llaves de luz',
      'Circuitos con caídas de tensión',
      'Incompatibilidades entre componentes',
      'Errores de conexión',
      'Reparaciones posteriores a reformas',
    ],
    outro: 'Consultá ejemplos con explicaciones técnicas, cálculos cuando corresponda y criterios de resolución.',
    finalLine: 'Analizá. Interpretá. Solucioná.',
  },
  {
    number: '3',
    title: 'Diagnóstico de fallas complejas e instalaciones antiguas',
    subtitle: 'Una guía práctica para situaciones donde encontrar el problema no es tan sencillo.',
    intro: [
      'No todas las viviendas tienen instalaciones modernas, planos actualizados o circuitos correctamente identificados.',
      'En muchos trabajos aparecen conductores antiguos, reparaciones improvisadas, conexiones ocultas y modificaciones realizadas durante años.',
      'Este tomo reúne casos para analizar esas situaciones.',
    ],
    listLabel: 'Encontrá ejemplos sobre:',
    items: [
      'Conductores con aislamiento deteriorado',
      'Instalaciones antiguas',
      'Conexiones ocultas',
      'Cableado dañado',
      'Problemas provocados por humedad',
      'Fallas intermitentes',
      'Canalizaciones deterioradas',
      'Modificaciones sin documentación',
      'Defectos mecánicos',
      'Instalaciones con múltiples problemas',
    ],
    outro: 'Cada actividad presenta síntomas, evidencia simulada, interpretación técnica, medidas correctivas y condiciones de verificación.',
    finalLine: 'Investigá. Identificá. Corregí.',
  },
  {
    number: '4',
    title: 'Casos prácticos de diagnóstico eléctrico profesional',
    subtitle: 'Aprendé a organizar diagnósticos completos, verificaciones e informes técnicos.',
    intro: [
      'Este tomo está orientado a situaciones donde el electricista necesita analizar varios aspectos de una instalación antes de definir una intervención.',
      'Incluye casos que combinan evaluaciones, cálculos, documentación y decisiones técnicas.',
    ],
    listLabel: 'Vas a encontrar:',
    items: [
      'Evaluaciones posteriores a reformas',
      'Relevamientos eléctricos domiciliarios',
      'Interpretación de resultados de verificaciones',
      'Análisis de cargas y circuitos',
      'Casos relacionados con protecciones',
      'Evaluación de instalaciones modificadas',
      'Ejemplos de documentación técnica',
      'Informes de diagnóstico',
      'Verificaciones posteriores a reparaciones',
      'Casos integrales con múltiples problemas',
    ],
    outro: 'Cada caso muestra cómo organizar la información, diferenciar defectos confirmados de hipótesis y documentar las medidas necesarias.',
    finalLine: 'Evaluá. Documentá. Verificá.',
  },
];

export const bonuses = [
  {
    number: '1',
    title: 'Guía profesional de diagramas eléctricos domiciliarios',
    price: 9990,
    points: [
      'Interpretá circuitos con diagramas claros y ejemplos prácticos.',
      'Accedé a esquemas organizados para comprender la distribución, el funcionamiento y la identificación de componentes eléctricos.',
      'Utilizá diagramas de tableros, iluminación, tomacorrientes, circuitos y sistemas de control.',
      'Incluye actividades para interpretar conexiones, identificar elementos y reconocer errores representados en casos simulados.',
      'Una herramienta visual para consultar cuando necesitás comprender un esquema.',
    ],
    finalLine: 'Observá. Interpretá. Comprendé.',
  },
  {
    number: '2',
    title: 'Manual profesional de mediciones eléctricas',
    price: 9990,
    points: [
      'Ejercicios para interpretar resultados y reconocer valores anormales.',
      'Consultá ejemplos de mediciones eléctricas con datos concretos y explicaciones de su interpretación.',
      'Incluye actividades con lecturas simuladas de tensión, corriente, continuidad, aislamiento y otros parámetros utilizados en verificaciones profesionales.',
      'Compará resultados, analizá posibles causas y aprendé a distinguir qué conclusiones permiten obtener los datos disponibles.',
      'Todo mediante ejemplos técnicos y ejercicios desarrollados.',
    ],
    finalLine: 'Medí con criterio. Interpretá. Evaluá.',
  },
  {
    number: '3',
    title: 'Fichas profesionales de diagnóstico e inspección eléctrica',
    price: 8990,
    points: [
      'Organizá cada trabajo con herramientas de registro listas para completar.',
      'Accedé a fichas, listas de verificación y modelos de informes para documentar trabajos domiciliarios.',
      'Utilizá recursos para relevamientos, inspecciones, identificación de fallas, registro de resultados y seguimiento de reparaciones.',
      'Mantené organizada la información de cada intervención, sin tener que diseñar un formulario desde cero.',
    ],
    finalLine: 'Relevá. Registrá. Documentá.',
  },
  {
    number: '4',
    title: 'Guía profesional de presupuestos y costos eléctricos',
    price: 9990,
    points: [
      'Calculá materiales, costos y presupuestos con mayor organización.',
      'Consultá ejemplos de presupuestos para trabajos y reparaciones domiciliarias.',
      'Incluye planillas de materiales, cálculos de mano de obra, ejemplos de costos y modelos para presentar cotizaciones.',
      'Adaptá cantidades, precios y condiciones a cada trabajo.',
      'Dejá de depender solamente de estimaciones improvisadas cuando necesitás preparar una propuesta para tu cliente.',
    ],
    finalLine: 'Calculá. Organizá. Presupuestá.',
  },
];
